/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Withdrawal_Field_EmailInputs */

const en_withdrawal_field_email = /** @type {(inputs: Withdrawal_Field_EmailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Confirmation to`)
};

const pl_withdrawal_field_email = /** @type {(inputs: Withdrawal_Field_EmailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Potwierdzenie na`)
};

/**
* | output |
* | --- |
* | "Confirmation to" |
*
* @param {Withdrawal_Field_EmailInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const withdrawal_field_email = /** @type {((inputs?: Withdrawal_Field_EmailInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Withdrawal_Field_EmailInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_withdrawal_field_email(inputs)
	return en_withdrawal_field_email(inputs)
});